var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.111 2c.932 0 1.698.72 1.772 1.632l.006.146v8.444a1.78 1.78 0 01-1.632 1.772L13.11 14H2.89a1.78 1.78 0 01-1.772-1.632l-.006-.146V3.778c0-.932.72-1.698 1.632-1.772L2.89 2H13.11zM6.153 8.444H2v3.778c0 .453.34.827.778.882l.11.007h10.223a.89.89 0 00.882-.777l.007-.112V8.444H9.847A1.952 1.952 0 018 9.778a1.95 1.95 0 01-1.792-1.19l-.055-.144zM14 5.654H2v1.902h4.507c.225 0 .415.168.441.392.064.536.516.94 1.052.94s.988-.404 1.052-.94a.444.444 0 01.359-.385l.082-.007H14V5.653zm-.889-2.765H2.89a.89.89 0 00-.882.777L2 3.778v.986h12v-.986a.89.89 0 00-.778-.882l-.11-.007z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.d1ca2d3d.svg";
export { ForwardRef as ReactComponent };